import React, { useEffect, useState } from 'react';
import AdminSidebar from 'admin/sidebar/AdminSidebar';
import { CiSearch } from "react-icons/ci";
import TopCustomers from 'admin/components/jobhistory/topcustomers';
import './Customer.css';
import TopCustomer from 'admin/components/dashboardcom/TopCustomer';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { formatDate, formatTimeInTimezone } from 'pages/utils/formdatedynamics';
import { Skeleton } from '@mui/material';

function Customers() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [topCustomerSideBardata, settopCustomerSideBardata] = useState([]);
  
  // --- Filter States ---
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [dateFilter, setDateFilter] = useState('');

  const navigator = useNavigate();
  const storedData = localStorage.getItem('topcustomerData');

  useEffect(() => {
    window.scrollTo(0, 0);
    if (storedData) {
      try {
        const topCustomerData = JSON.parse(storedData);
        settopCustomerSideBardata(topCustomerData);
      } catch (error) {
        console.error("Invalid JSON format in localStorage:", error);
      }
    }
    
    const fetchData = async () => {
      const token = localStorage.getItem('accessTokenAdmin');
      const apiUrl = 'https://backend.washta.com/api/admin/JobHistory';

      try {
        const response = await axios.get(apiUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setData(response.data.data.reverse());
      } catch (err) {
        console.log(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Custom ID format function: WAS-2026-9883A1
  const getCustomId = (item) => {
    if (!item?._id || !item?.date) return item?._id || "";
    const year = new Date(item.date).getFullYear();
    const lastSix = item._id.slice(-6).toUpperCase();
    return `WAS-${year}-${lastSix}`;
  };

  // --- Multi-Filter Logic ---
  const filteredData = data?.filter((item) => {
    // Basic billing status check
    if (item.billingStatus === "non-paid") return false;

    const customId = getCustomId(item).toLowerCase();
    const username = item.customerId?.username?.toLowerCase() || "";
    const lowerSearch = searchQuery.toLowerCase();

    // 1. Search by Custom ID or Name
    const matchesSearch = customId.includes(lowerSearch) || username.includes(lowerSearch);

    // 2. Filter by Status
    const matchesStatus = statusFilter === "" || item.status === statusFilter;

    // 3. Filter by Date
    let matchesDate = true;
    if (dateFilter) {
      const itemDateOnly = item.date?.split('T')[0];
      matchesDate = itemDateOnly === dateFilter;
    }

    return matchesSearch && matchesStatus && matchesDate;
  });

  return (
    <div className='mainDiv-all-sideBar'>
      <div className='div-sidebar'>
        <AdminSidebar />
      </div>
      <div className='div-Dashbaord'>
        <h1 className='h1-all-heading'>Customers Booking</h1>
        <div className="dashboard">
          <div className='styles-div'>
            <div className="chart-container">
              
              {/* --- Filter Section --- */}
              <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
                
                {/* Search Input */}
                <div className='input-feild-dic-icon' style={{ flex: 1, margin: 0, position: 'relative' }}>
                  <CiSearch className='icon-serach-box-input' style={{ position: 'absolute', left: '10px', top: '18%' }} />
                  <input
                    placeholder='Search by name or ID (WAS-...)'
                    className='input-feild-class-job-history'
                    style={{ paddingLeft: '35px', width: '100%' }}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>

                {/* Status Dropdown */}
                <select 
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                 className='invoice-search-icon-div'
              style={{ width: '130px', cursor: 'pointer' }}
                >
                  <option value="">All Status</option>
                  <option value="ongoing">Ongoing</option>
                  <option value="completed">Completed</option>
                  <option value="pending">Pending</option>
                </select>

                {/* Styled Small Date Input */}
                <input 
                  type="date"
                  value={dateFilter}
                  onChange={(e) => setDateFilter(e.target.value)}
                  className='input-feild-class-job-history'
                  style={{ 
    width: '140px', 
    borderRadius: '15px',
    cursor: 'pointer',
    fontSize: '13px',
    color: '#666',
    border: '1px solid #e0e0e0',
    padding: '5px 10px',
    backgroundColor: '#fdfdfd',
    transition: 'all 0.3s ease',
    outline: 'none'
  }}
                />

                {/* Reset Button */}
                {/* <button 
                  onClick={() => { setSearchQuery(''); setStatusFilter(''); setDateFilter(''); }}
                  style={{ padding: '0 15px', height: '42px', borderRadius: '8px', border: '1px solid #ddd', background: '#f5f5f5', cursor: 'pointer' }}
                >
                  Reset
                </button> */}
              </div>

              <div
  className="responsive-container"
  style={
    !loading && filteredData?.length === 0
      ? {
          gridTemplateColumns: "none",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }
      : {}
  }
>
  {loading ? (
    Array.from(new Array(6)).map((_, index) => (
      <div key={index} className="responsive-item">
        <div
          className="customer-card-skeleton"
          style={{
            padding: '15px',
            background: '#fff',
            borderRadius: '10px',
          }}
        >
          <Skeleton
            variant="rectangular"
            height={80}
            style={{ borderRadius: '10px' }}
          />
        </div>
      </div>
    ))
  ) : filteredData?.length === 0 ? (
    <div
      style={{
        textAlign: 'center',
        padding: '20px',
        width: '100%',
      }}
    >
      No bookings found.
    </div>
  ) : (
    filteredData?.map((item) => (
      <div key={item._id} className="responsive-item">
        <TopCustomer
  Item={item}
  onDeleteInoive={item?._id || ""}
  ID={item?.customerId?._id || ""}
  paymentId={item?.paymentId?.slice?.(0, 4) || ""}
  Avatar={item?.customerId?.avatar || ""}
  paymnet={item?.cost || 0}
  textpopupBtn="Share details"
  status={item?.status || ""}
  orderTime={formatTimeInTimezone(item?.paidAt || item?.date)}
  orderDate={formatDate(item?.paidAt || item?.date)}
  orderId={getCustomId(item)}
  carPlate={item?.vehicleId?.vehiclePlateNumber || ""}
  carType={item?.vehicleId?.vehicleType || ""}
  vist={
    formatDate(item?.paidAt || item?.date) +
    " At " +
    formatTimeInTimezone(item?.paidAt || item?.date)
  }
  car={item?.vehicleId?.vehicleName || ""}
  buyerName={item?.customerId?.fullName || ""}
  show={true}
  Completed={item?.status || ""}
  name={item?.customerId?.fullName || ""}
  spent={item?.cost || 0}
/>
      </div>
    ))
  )}
</div>
    </div>
    </div>
          <div className='styles-div-text'>
            <TopCustomers Data={topCustomerSideBardata} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Customers;